 export const SERVICE_URL = "api/auth/login";
 export const mapurl = "https://www.aegrl.com/geoserver/gwc/service/wms";
 export const MapLayer = "JAN2019:JAN-2019"

/******* Localhost : 8080 Environment ******/
/***local-start***/
// export const serverurl = "http://localhost:8080/RapidI-war/WRU/Gateway/";
// export const serverleturl ="http://localhost:8080/RapidI-war/";
// export const imageServleturl = "http://localhost:8080/RapidI-war/TraningVideosServlet?videoName="
/***local-end***/

/******* Development Environment - homepage : /IFR in package.json ******/

// Development Environment  - homepage : /IFR in package.json  - 8787 Environment

/***dev-start***/
// export const serverurl = "http://144.76.39.199/RapidI-war/WRU/Gateway/";
// export const serverleturl = "http://144.76.39.199/RapidI-war/";
// export const imageServleturl = "http://144.76.39.199/RapidI-war/TraningVideosServlet?videoName="
/***dev-end***/

 
/******* GR1 - Production Environment - homepage : /IFR in package.json ******/

/***gr1-start***/
// export const serverurl = "https://gr1.infofleet.com/RapidI-war/WRU/Gateway/";
// export const serverleturl = "https://gr1.infofleet.com/RapidI-war/";
// export const imageServleturl = "https://gr1.infofleet.com/RapidI-war/TraningVideosServlet?videoName="
/***gr1-end***/

/******* GR4 - Production Environment - homepage : /IFR in package.json ******/

/***gr4-start***/
export const serverurl = "https://gr4.infofleet.com/RapidI-war/WRU/Gateway/";
export const serverleturl = "https://gr4.infofleet.com/RapidI-war/";
export const imageServleturl = "https://gr4.infofleet.com/RapidI-war/TraningVideosServlet?videoName="
/***gr4-end***/


/******* GR5 - Production Environment - homepage : /IFR in package.json ******/
/***gr5-start***/
// 
// export const serverurl = "https://gr5.infofleet.com/RapidI-war/WRU/Gateway/";
// export const serverleturl = "https://gr5.infofleet.com/RapidI-war/";
// export const imageServleturl = "https://gr5.infofleet.com/RapidI-war/TraningVideosServlet?videoName="
// 
/***gr5-end***/

/******* IS2  - Production Environment - homepage : /IFR in package.json ******/

/***is2-start***/
//export const serverurl = "https://is2.infofleet.com/RapidI-war/WRU/Gateway/";
//export const serverleturl = "https://is2.infofleet.com/RapidI-war/";
//export const imageServleturl = "https://is2.infofleet.com/RapidI-war/TraningVideosServlet?videoName="
/***is2-end***/

//******* 4G - Production Environment - homepage : / in package.json ******/

/***4g-start***/
//  export const serverurl = "https://4g.infofleet.com/RapidI-war/WRU/Gateway/";
//  export const serverleturl = "https://4g.infofleet.com/RapidI-war/";
//  export const imageServleturl = "https://4g.infofleet.com/RapidI-war/TraningVideosServlet?videoName="
/***4g-end***/
